import Vue from "vue";
import Router from "vue-router";
// import Default from '@/views/Default';
const Home = resolve => require(["@/views/Home"], resolve);
const Default = resolve => require(["@/views/Default"], resolve);
const Ysh = resolve => require(["@/views/Ysh"], resolve);

const Ylxd = resolve => require(["@/views/Ylxd"], resolve);
const Ule = resolve => require(["@/views/Ule"], resolve);
const Yzg = resolve => require(["@/views/Yzg"], resolve);
const Ylyx = resolve => require(["@/views/Ylyx"], resolve);
const Ylzb = resolve => require(["@/views/Ylzb"], resolve);
const Yznp = resolve => require(["@/views/Yznp"], resolve);
const Fzlc = resolve => require(["@/views/Fzlc"], resolve);
const Zbgs = resolve => require(["@/views/Zbgs"], resolve);
const Index = resolve => require(["@/views/index"], resolve);
//const GoodsList = resolve => require(["@/views/GoodsList"], resolve);
const Saas = resolve => require(["@/views/Sass"], resolve);
const Gsjj = resolve => require(["@/views/Gsjj"], resolve);
const Zzjg = resolve => require(["@/views/Zzjg"], resolve);
const Qywh = resolve => require(["@/views/Qywh/index"], resolve);
const Wlcx = resolve => require(["@/views/Wlcx"], resolve);


//const Login = resolve => require(["@/components/Login"], resolve);

Vue.use(Router);

export default new Router({
  // 配置单页应用的基本路径
  base: "/pc/",
  mode: "history",
  routes: [
    // 默认页
    {
      path: "/",
      name: "Home1",
      component: Home
    },
    // 新首页
    {
      path: "/Home",
      name: "Home",
      component: Home
    },
    {
      path: "/Default",
      name: "Default",
      component: Default
    },
    // 邮生活
    {
      path: "/Ysh",
      name: "Ysh",
      component: Ysh
    },
    // 邮乐小店
    {
      path: "/Ylxd",
      name: "Ylxd",
      component: Ylxd
    },
    // 邮乐商城
    {
      path: "/Ylsc",
      name: "Ylsc",
      component: Ule
    },
    // 邮乐优鲜
    {
      path: "/Ylyx",
      name: "Ylyx",
      component: Ylyx
    },
    // 邮乐直播
    {
      path: "/Ylzb",
      name: "Ylzb",
      component: Ylzb
    },
    // 邮掌柜
    {
      path: "/Yzg",
      name: "Yzg",
      component: Yzg
    },
    // 邮政农品
    {
      path: "/Yznp",
      name: "Yznp",
      component: Yznp
    },
    // 关于我们 Gywm
    {
      path: "/Fzlc",
      name: "Fzlc",
      component: Fzlc
    },
    // 登录
    // {
    //   path: "/Login",
    //   name: "Login",
    //   component: Login
    // },
    // 商品列表
    // {
    //   path: "/GoodsList",
    //   name: "GoodsList",
    //   component: GoodsList
    // },
    // 招标公示
    {
      path: "/Zbgs",
      name: "Zbgs",
      component: Zbgs
    },
    {
      path: "/Wlcx",
      name: "Wlcx",
      component: Wlcx
    },
    // Saas
    {
      path: "/Saas",
      name: "Saas",
      component: Saas
    },
    // 公司简介
    {
      path: "/Gsjj",
      name: "Gsjj",
      component: Gsjj
    },
    // 组织架构
    {
      path: "/Zzjg",
      name: "Zzjg",
      component: Zzjg
    },
    // 企业文化
    {
      path: "/Qywh",
      name: "Qywh",
      component: Qywh
    },
    // 商城首页
    {
      path: "/Index",
      name: "Index",
      component: Index
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js